import Modal from './Modal.jsx';
import './ErrorModal.css';

export default function ErrorModal({ open, title, lines = [], onClose }) {
  // Prefer the parsed detail lines; fall back to the raw backend message
  // when there's nothing more specific to show.
  const content = lines.length > 0 ? lines : title ? [title] : [];

  return (
    <Modal open={open} onClose={onClose} className="customer-portal-error-modal" maxWidth="420px">
      <button type="button" className="customer-portal-error-modal__close" onClick={onClose} aria-label="Close">
        ✖
      </button>

      <div className="customer-portal-error-modal__icon" aria-hidden="true">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="7.5" x2="12" y2="13" />
          <line x1="12" y1="16.5" x2="12.01" y2="16.5" />
        </svg>
      </div>

      <div className="customer-portal-error-modal__heading">Couldn't save order</div>

      {content.length > 0 && (
        <div className="customer-portal-error-modal__body">
          {content.length > 1 ? (
            <ul className="customer-portal-error-modal__list">
              {content.map((line, i) => (
                <li key={i}>{line}</li>
              ))}
            </ul>
          ) : (
            <p>{content[0]}</p>
          )}
        </div>
      )}

      <div className="customer-portal-error-modal__footer">
        <button type="button" className="customer-portal-btn customer-portal-btn--primary" onClick={onClose}>
          Got it
        </button>
      </div>
    </Modal>
  );
}
